const toCents = (n: number): number => Math.round(n * 100);

export function computeLocalOrderTotalMismatchFlags(
    currentOrderTotal: number,
    expectedOrderTotalFromLines: number,
): {
    localTotalFormulaMismatch: { extractedTotal: number; sumOfTotalsSection: number } | null;
    localGrandTotalVsAboveLineItemsWithFeesMismatch: {
        extractedTotal: number;
        expectedFromAboveLineItems: number;
    } | null;
} {
    if (toCents(currentOrderTotal) === toCents(expectedOrderTotalFromLines)) {
        return {
            localTotalFormulaMismatch: null,
            localGrandTotalVsAboveLineItemsWithFeesMismatch: null,
        };
    }
    return {
        localTotalFormulaMismatch: {
            extractedTotal: currentOrderTotal,
            sumOfTotalsSection: expectedOrderTotalFromLines,
        },
        localGrandTotalVsAboveLineItemsWithFeesMismatch: {
            extractedTotal: currentOrderTotal,
            expectedFromAboveLineItems: expectedOrderTotalFromLines,
        },
    };
}
